import React from 'react';
import { Text } from 'library';
import { useMediaQuery } from '@material-ui/core';
import theme from 'theme';

const BioDetail = ({ bio }: { bio: string }) => {
    const xsOnly = useMediaQuery(theme.breakpoints.only('xs'));
    return (
        <Text
            variant={xsOnly ? 'body2' : 'body1'}
            textStyle={{
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
            }}
        >
            "{bio}"
        </Text>
    );
};

export default BioDetail;
